const modifyProposedDiscussion = function ({ commit }, { field, value }) {
  commit("UPDATE_PROPOSED_DISCUSSION", { field, value });
};

export default modifyProposedDiscussion;
